
import { Component, Emit, Inject, Prop, Vue } from "vue-property-decorator";
import { Container } from "inversify";
import { SignUpStore } from "../../../../stores/sign-up/SignUpStore";
import FormInput from "../../../../molecules/form/FormInput.vue";
import { EmailVerificationStore } from "../../../../stores/sign-up/EmailVerificationStore";
import { NotificationStore } from "../../../../../../common/src/stores/NotificationStore";
import ActionButton from "../../../../../../common/src/components/ActionButton.vue";
import { Nullable, SignUpBody, UserRoleInOrganization } from "@gsx/common";
import FormEnumMultiSelect from "../../../../molecules/form/FormEnumMultiSelect.vue";
@Component({
    components: {
        ActionButton,
        FormInput,
        FormEnumMultiSelect,
    },
})
export default class ProfileSignupStep extends Vue {
    @Inject("container") readonly container!: Container;
    readonly signUpStore: SignUpStore = this.container.get(SignUpStore);
    readonly emailVerificationStore: EmailVerificationStore =
        this.container.get(EmailVerificationStore);
    readonly notificationStore: NotificationStore = this.container.get(NotificationStore);
    terms: boolean = false;
    @Prop() value!: Nullable<SignUpBody>;

    get UserRoleInOrganization() {
        return UserRoleInOrganization;
    }

    @Emit()
    submit() {
        //
    }
}
